export default "__VITE_ASSET__c8c9f067__"